const setDynamicYieldRecommendationContext = function(path: string, DY) {
    const data: string[] = [];
    let type: string = 'OTHER';
    const strippedPath = path.split('?')[0]?.split('#')[0] || '/';
    const normalizedPath = strippedPath;
    if (normalizedPath === "/") {
        type = 'HOMEPAGE';
    } else if (normalizedPath.startsWith('/products/dp')) {
        type = 'PRODUCT';
        const pdpProduct = localStorage.getItem('pdpProduct')
        let sku = ''
        if (pdpProduct) {
            try {
                const product = JSON.parse(pdpProduct)
                sku = product.sku
            } catch (e) {
                console.error('Invalid JSON in localStorage', e)
            }
        }
        data.push(sku)
    } else if (normalizedPath.startsWith('/products') || normalizedPath.startsWith('/search')) {
        type = 'CATEGORY';
        data.push('Supplements')
    } else {
        data.push(path);
    }
    DY.recommendationContext = {type: type, data: data}
}

export { setDynamicYieldRecommendationContext }